import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; experience_modules: number; experience_domains: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; consistency_passed: boolean; accessibility_wcag_aa_met: boolean;
  cognitive_load_optimized: boolean; motion_standards_met: boolean;
  performance_perception_met: boolean; design_qa_passed: boolean; gaps?: string[];
};

export type Xdb001Status = {
  sprint_id: string; objectives: number; experience_modules: number; experience_domains: number;
  experience_design: boolean; accessibility: boolean; motion_design: boolean;
  cognitive_load: boolean; design_qa: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const experienceDesignXdb001Api = {
  dashboard: () => fetchG<SprintDashboard>('/xdb001/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/xdb001/objectives').then((r) => r.objectives),
  experienceModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/xdb001/experience-modules').then((r) => r.modules),
  experienceDomains: () => fetchG<{ domains: { key: string; name: string; category: string }[] }>('/xdb001/experience-domains').then((r) => r.domains),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/xdb001/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/xdb001/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/xdb001/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/xdb001/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Xdb001Status>('/xdb001/status'),
};
